//所有有关用户信息的网络请求
import http from '../utils/http'


//查询全部数据(已废弃)
// export function apiRecordinfo({page,size}){
//     return http({
//       url:`/client/ccManageLog/${page}/${size}`,
//       method:'get',
//     })
//   }

 // 操作/client/ccManageLog/{complaintId}/{page}/{size}
export function apiOperationRecords(params){
  return http({
    url:`/client/ccManageLog`,
    method:'get',
    params:params,
  })
}

//导入
export function apiImportFile(params){
  return http({
    url:'/client/ccManageLog/upload',
    method:'post',
    data:params,
    headers:{
      'content-type':'multipart/form-data'
    }
  })
}

//导出客诉管理日志表
export function apiLogSheet(params){
  return http({
    url:`/client/ccManageLog/download`,
    method:'get',
    params:params,
    responseType: 'blob'
  })
}